import { getGlobalSettings } from '../../../stores';
import {
  defaultTtsVoice,
  Design,
  DesignFillerPrompt,
  LanguageCode,
  TextToSpeechVoiceOrDefault
} from '../../../types';

export type GetFillerPromptTextProps = {
  languageCode?: LanguageCode | null;
  prompt: DesignFillerPrompt;
  serialized?: Design;
  ttsVoice?: TextToSpeechVoiceOrDefault;
};

export function getFillerPromptText({
  languageCode,
  prompt,
  serialized,
  ttsVoice
}: GetFillerPromptTextProps): string {
  const { language, ...globalSetings } = getGlobalSettings();
  languageCode ??= language;
  ttsVoice ??= globalSetings.ttsVoices?.[languageCode] ?? defaultTtsVoice;
  serialized ??= window.apm.serialized;
  const { ttsOverrides } = serialized.rootSettings.features;

  if (ttsOverrides && ttsVoice && ttsVoice !== defaultTtsVoice) {
    const text = prompt?.ttsOverrides?.[languageCode]?.[ttsVoice]?.text;
    if (text) {
      return text;
    }
  }
  return prompt.transcripts.find(({ locale }) => {
    return locale === languageCode;
  })?.transcript ?? '';
}
